import store from 'src/js/store';
import actions from '../actions';

const show = () => {
  store.dispatch(actions.show());
};

export default show;
